import { LinkAction } from '@leverege/molten/routes';
export default LinkAction.create({
  id: 'recovr.homeLink',
  matches: {
    use: 'navBar',
    client: 'Main'
  },
  icon: 'https://recovr-ui-assets.storage.googleapis.com/blueprintNavIcons/home-nav.svg',
  name: 'Home',
  path: '/'
});